import { render, staticRenderFns } from "./MapUI.vue?vue&type=template&id=1528e678&scoped=true&"
import script from "./MapUI.vue?vue&type=script&lang=js&"
export * from "./MapUI.vue?vue&type=script&lang=js&"
import style0 from "./MapUI.vue?vue&type=style&index=0&id=1528e678&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1528e678",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
